// --- <my-tab-group> ----------------------------------------------------

 import {
        LitElement,
        html,
        css,
      } from "https://cdn.jsdelivr.net/npm/lit@3.3.1/+esm";
class MyTabGroup extends LitElement {
  static properties = {
    active: { type: String, reflect: true },
    hideNav: { type: Boolean, reflect: true }
  };

  static styles = css`
    :host {
      display: block;
      opacity: 1;
    }
    
    .nav.hidden {
      display: none !important;
    }
    .content {
      overflow: visible; /* 确保 sticky 可以工作 */
    }
  `;

  constructor() {
    super();
    this.active = "";
    this.hideNav = false;
  }

  firstUpdated() {
    // 初始化默认选项
    const tabs = this.querySelectorAll('my-tab[slot="nav"]');
    console.log("---- ~ MyTabGroup ~ firstUpdated ~ tabs:", tabs)
    const enabledTabs = [...tabs].filter((t) => !t.hasAttribute("disabled"));

    // 如果没有有效的 tab,则隐藏 nav
    if (enabledTabs.length === 0) {
      this.hideNav = true;
    }

    if (enabledTabs.length === 1) {
      this.hideNav = true;
    }
    
    const firstEnabledTab = enabledTabs[0];
    if (firstEnabledTab) this.select(firstEnabledTab.getAttribute("panel"));

    // 组件初始化完成，显示组件
    requestAnimationFrame(() => {
      const tabStickySection = this.closest('.as-tab-sticky-section');
      if (tabStickySection) {
        tabStickySection.classList.add('loaded');
      }
    });
  }


  disconnectedCallback() {
    super.disconnectedCallback();
  }

  select(name) {
    this.active = name;
    this.querySelectorAll("my-tab").forEach((tab) => {
      tab.toggleAttribute("active", tab.getAttribute("panel") === name);
    });
    this.querySelectorAll("my-tab-panel").forEach((panel) => {
      panel.toggleAttribute("active", panel.getAttribute("name") === name);
    });
  }

  render() {
    return html`
      <div
        class="nav ${this.hideNav ? 'hidden' : ''}"
        part="nav"
        @tab-select=${(e) => this.select(e.detail.name)}
      >
        <slot name="nav"></slot>
      </div>
      <div class="content" part="content">
        <slot name="content"></slot>
      </div>
    `;
  }
}
customElements.define("my-tab-group", MyTabGroup);

// --- <my-tab> ----------------------------------------------------------
class MyTab extends LitElement {
  static properties = {
    panel: { type: String },
    active: { type: Boolean, reflect: true },
    disabled: { type: Boolean, reflect: true },
  };

  

  createRenderRoot() {
    return this;
  }

  updated(changedProperties) {
    super.updated(changedProperties);
   
  }

  render() {
    return html`<slot></slot>`;
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("click", this._onClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this._onClick);
    super.disconnectedCallback();
  }

  _onClick = () => {
    if (this.disabled) return;
    this.dispatchEvent(
      new CustomEvent("tab-select", {
        detail: { name: this.panel },
        bubbles: true,
        composed: true,
      })
    );
  };
}
customElements.define("my-tab", MyTab);

// --- <my-tab-panel> ----------------------------------------------------
class MyTabPanel extends LitElement {
  static properties = {
    name: { type: String, reflect: true },
    active: { type: Boolean, reflect: true },
  };

  // 关闭 Shadow DOM，允许外部样式（如 Tailwind）直接作用于内容
  createRenderRoot() {
    return this;
  }

  render() {
    return html`<slot></slot>`;
  }
}
customElements.define("my-tab-panel", MyTabPanel);

// --- <see-more-btn> ----------------------------------------------------
class SeeMoreBtn extends LitElement {
  static properties = {
    expanded: { type: Boolean, reflect: true },
    initialCount: { type: Number },
  };

  createRenderRoot() {
    return this;
  }

  constructor() {
    super();
    this.expanded = false;
    this.initialCount = 4;
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this._onClick);
    
    // 监听 tab 切换事件,重置展开状态
    const tabGroup = this.closest('my-tab-group');
    if (tabGroup) {
      tabGroup.addEventListener('tab-select', () => {
        this.expanded = false;
        this._updateProductVisibility();
        this._updateParentExpandedState();
      });
    }
    
    // 初始化产品显示状态
    this._updateProductVisibility();
    this._updateButtonVisibility();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick);
    super.disconnectedCallback();
  }

  _onClick = () => {
    const wasExpanded = this.expanded;
    this.expanded = !this.expanded;
    this._updateProductVisibility();
    this._updateParentExpandedState();
    
    // 如果是从展开状态变为关闭状态，滚动到按钮位置
    if (wasExpanded && !this.expanded) {
      // 使用 setTimeout 确保 DOM 更新完成后再滚动
      setTimeout(() => {
        this.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 100);
    }
    
    // 触发事件通知 MyTabGroup 内容高度已变化
    this.dispatchEvent(
      new CustomEvent('content-height-changed', {
        bubbles: true,
        composed: true,
      })
    );
  };

  _updateProductVisibility() {
    const panel = this.closest('my-tab-panel');
    if (!panel) return;

    const products = panel.querySelectorAll('.product-item');
    products.forEach((product, index) => {
      if (this.expanded || index < this.initialCount) {
        product.style.display = '';
      } else {
        product.style.display = 'none';
      }
    });

    // 更新按钮文本
    const svgIconDown = '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none"><path d="M5.03101 8L0 0L1.46382 0L5.5 6.56067L5.37209 6.49372H5.65633L5.52842 6.56067L9.53618 0L11 0L5.9832 8H5.03101Z" fill="#151515"/></svg>';
    const svgIconUp = '<svg style="transform: rotate(180deg);" xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none"><path d="M5.03101 8L0 0L1.46382 0L5.5 6.56067L5.37209 6.49372H5.65633L5.52842 6.56067L9.53618 0L11 0L5.9832 8H5.03101Z" fill="#151515"/></svg>';
    this.innerHTML = this.expanded 
      ? `<p><span>Show Less </span> ${svgIconUp}</p>` 
      : `<p><span>See More </span> ${svgIconDown}</p>`;
  }

  _updateButtonVisibility() {
    const panel = this.closest('my-tab-panel');
    if (!panel) return;

    const products = panel.querySelectorAll('.product-item');
    // 只有产品数量大于 initialCount 时才显示按钮
    if (products.length <= this.initialCount) {
      this.style.display = 'none';
    } else {
      this.style.display = '';
    }
  }

  _updateParentExpandedState() {
    const panel = this.closest('my-tab-panel');
    if (!panel) return;
    
    // 将 expanded 状态同步到父组件
    panel.toggleAttribute('expanded', this.expanded);
  }

  render() {
    return html`<slot></slot>`;
  }
}
customElements.define('see-more-btn', SeeMoreBtn);

// --- <discount-price-calculator> ----------------------------------------------------------
// class DiscountPriceCalculator extends LitElement {
//   static properties = {
//     originalPrice: { type: Number, attribute: 'original-price' },
//     discount: { type: Number },
//     currencySymbol: { type: String, attribute: 'currency-symbol' },
//     showCurrency: { type: Boolean, attribute: 'show-currency' }
//   };

//   static styles = css`
//     :host {
//       display: inline-flex;
//       align-items: center;
//       gap: 8px;
//       font-weight: bold;
//       color: var(--discout-red, #DB3844);
//     }
//     .discounted-price {
//       font-size: 12px;
//       color: var(--discout-red, #DB3844);
//     }
//     @media screen and (max-width: 999px) {
//       .discounted-price {
//         font-size: 8px;
//       }
//     }
//   `;

//   constructor() {
//     super();
//     this.originalPrice = 0;
//     this.discount = 0;
//     this.currencySymbol = '$';
//     this.showCurrency = true;
//   }

//   get calculatedPrice() {
//     if (!this.originalPrice || !this.discount || this.discount <= 0) {
//       return null;
//     }
//     // 计算折扣后的价格: 原价 * (100 - 折扣) / 100
//     const discountPercent = 100 - this.discount;
//     const finalPrice = (this.originalPrice * discountPercent) / 100;
//     return finalPrice;
//   }

//   formatPrice(price) {
//     if (price === null) return '';
    
//     // 格式化价格，保留2位小数
//     const formatted = (price / 100).toFixed(2);
    
//     if (this.showCurrency) {
//       return `${this.currencySymbol}${formatted}`;
//     }
//     return formatted;
//   }

//   render() {
//     const price = this.calculatedPrice;
    
//     if (price === null) {
//       return html``;
//     }

//     return html`
//       <span class="discounted-price">
//         ${this.formatPrice(price)}
//       </span>
//     `;
//   }
// }
// customElements.define('discount-price-calculator', DiscountPriceCalculator);





//定义一个web component  作用是将子元素所有包含标签的文本转换成html 标签

class HtmlTags extends HTMLElement {
  connectedCallback() {
    this.processTextNodes();
  }
  
  processTextNodes() {
    const walker = document.createTreeWalker(
      this,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    
    const textNodes = [];
    let node;
    while (node = walker.nextNode()) {
      // 避免处理已经转换过的节点
      if (!node.parentNode.hasAttribute('data-html-processed')) {
        textNodes.push(node);
      }
    }
    
    textNodes.forEach(textNode => {
      const text = textNode.textContent.trim();
      
      // 检查文本是否包含完整的 HTML 标签
      if (text && /<[^>]+>.*<\/[^>]+>|<[^>]+\/>/.test(text)) {
        try {
          // 创建临时容器来解析 HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = text;
          
          // 检查是否成功解析（防止不完整的标签）
          if (tempDiv.children.length > 0 || tempDiv.textContent !== text) {
            // 将解析后的节点插入到原位置
            const fragment = document.createDocumentFragment();
            while (tempDiv.firstChild) {
              fragment.appendChild(tempDiv.firstChild);
            }
            
            // 标记父元素已处理，避免重复处理
            textNode.parentNode.setAttribute('data-html-processed', 'true');
            textNode.parentNode.replaceChild(fragment, textNode);
          }
        } catch (error) {
          console.warn('HtmlTags: 无法解析HTML内容:', text, error);
        }
      }
    });
  }
}
customElements.define('html-tags', HtmlTags);
